<template>
  <div>
    <div v-if="config.showBar" style="text-align: left ; margin-bottom: 0.02rem">
      <el-button class="add_btn" icon="el-icon-plus" size="mini" @click="add">新增</el-button>
      <el-button class="edit_btn" icon="el-icon-edit" size="mini" @click="edit">编辑</el-button>
      <el-button class="del_btn" icon="el-icon-delete" size="mini" @click="del">删除</el-button>
    </div>
    <div class="common-table">
      <el-table
        v-loading="config.loading"
        :data="tableData"
        stripe
        highlight-current-row
        height="70vh"
        @current-change="handleCurrentChange">
        <el-table-column
          label="序号"
          width="85%">
          <template slot-scope="scope">
            <span style="text-align: center">
              {{ (config.page - 1) * config.limit + scope.$index +1 }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="item in tableLabel"
          :key="item.prop"
          :sortable="item.sortable"
          :label="item.label"
          :width="item.width ? item.width : ''"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span style="text-align: center;">{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="page"
        :current-page.sync="config.page"
        :page-sizes="config.sizes"
        :page-size="config.limit"
        layout="sizes, prev, pager, next"
        :total="config.count"
        @size-change="sizeChange"
        @current-change="changePage">
      </el-pagination>
    </div>
  </div>

</template>

<style>
  .page{
    text-align: left;
  }
</style>

<script>
export default {
  name: 'CommonTable',
  props: {
    tableLabel: Array,
    tableData: Array,
    config: Object
  },
  data() {
    return {}
  },
  methods: {
    edit() {
      this.$emit('edit')
    },
    del() {
      this.$emit('delete')
    },
    add() {
      this.$emit('add')
    },
    changePage(page) {
      this.$emit('changePage', page)
    },
    sizeChange(size) {
      this.$emit('sizeChange', size)
    },
    handleCurrentChange(val) {
      this.$emit('currentChange', val)
    }
  }
}
</script>

<style lang="scss" scoped>
  .common-table {
    background-color: white;
    position: relative;
    height: 75vh;
  }
  @import "../scss/commonTableVue";
</style>
